export const toTitleCase = (str: string | undefined) => {
  if (str) {
    return str.replace(
      /\w\S*/g,
      (txt: string) =>
        txt.charAt(0).toUpperCase() + txt.substring(1).toLowerCase(),
    )
  }
  return
}

export const splitProvinceString = (str: string | undefined) => {
  if (str && str.toLowerCase() === "novascotia") {
    return `${str.substring(0, 4)} ${str.substring(4, 10)}`
  }
  return str
}

export const extractNumberInParentheses = (text: string) => {
  const match = text.toString().match(/\((\d+)\)/)
  return match ? parseInt(match[1], 10).toString() : text
}
